import AddCircleOutlineIcon from "mdi-react/AddCircleOutlineIcon";
import React, { useRef, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useToggle } from "../../hooks";
import Header from "../App/Header/Header";
import CikModal from "./CikListModal/CikModal";
import CikTypeList from "./CikTypeList/CikTypeList";
import "./CikList.scss";

export const CikList = ({ user }) => {
  const [showModal, toggleShowModal] = useToggle(false);
  const [shouldRefresh, toggleShouldRefresh] = useToggle(false);
  const [action, setAction] = useState([]);
  const [show, setShow] = useState(false);
  const [searchInput, setSearchInput] = useState(null);

  // const history = useHistory();

  const handleCloseModal = () => {
    toggleShowModal();
    toggleShouldRefresh();
  };

  const setAlertShow = (val) => {
    setShow(val);
  };

  const isaddOrUpdate = (response) => {
    setAction({ response });
  };

  return (
    <>
      <Header user={user} title={"Keywords"} />
      <div
        className="sticky"
        style={{
          width: "100%",
          zIndex: "100",
          paddingLeft: "10px",
          paddingRight: "10px",
        }}
        id="main_sticky"
      >
        <Row className="">
          <Col
            xs={12}
            className="d-flex justify-content-start align-items-baseline"
          >
            <div className="sticky-custom mb-4">
              <Button
                variant="default"
                className="add-button btn-outline-deal-style roundedEdges"
                size="xs"
                onClick={toggleShowModal}
              >
                <AddCircleOutlineIcon className="p-1" />
                <span className="keyWLittleDown">Add CIK</span>
              </Button>
            </div>

            <div className="ml-3 shadow roundedEdges">
              <input
                type="text"
                className="form-control roundedEdges"
                placeholder="Search BDC"
                onChange={(v) => setSearchInput(v.target.value)}
                value={searchInput}
              />
            </div>
          </Col>
        </Row>
      </div>
      <Container className="MainContent keywordsList">
        <Row>
          <CikTypeList
            refresh={shouldRefresh}
            action={action}
            show={show}
            setAlertShow={setAlertShow}
            searchInput={searchInput}
          />
        </Row>
      </Container>
      <CikModal
        show={showModal}
        onClose={handleCloseModal}
        userAction={isaddOrUpdate}
        setAlertShow={setAlertShow}
      />
    </>
  );
};

export default CikList;
